import { GlButton, GlButtonGroup, GlTooltipDirective } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import SettingsDropdown from './settings_dropdown.vue?vue3';
import DiffStats from './diff_stats.vue?vue3';
import { sanitize } from '~/lib/dompurify';
import { keysFor, MR_COLLAPSE_ALL_FILES, MR_EXPAND_ALL_FILES } from '~/behaviors/shortcuts/keybindings';
import { Mousetrap } from '~/lib/mousetrap';
const createHotkeyHtml = (key)=>`<kbd class="flat gl-ml-1" aria-hidden=true>${key}</kbd>`;
export default {
    name: 'DiffAppControls',
    components: {
        DiffStats,
        SettingsDropdown,
        GlButton,
        GlButtonGroup
    },
    directives: {
        glTooltip: GlTooltipDirective
    },
    props: {
        hasChanges: {
            type: Boolean,
            required: true
        },
        diffsCount: {
            type: [
                String,
                Number
            ],
            default: '',
            required: false
        },
        addedLines: {
            type: Number,
            required: false,
            default: null
        },
        removedLines: {
            type: Number,
            required: false,
            default: null
        },
        showWhitespace: {
            type: Boolean,
            required: true
        },
        diffViewType: {
            type: String,
            required: true
        },
        viewDiffsFileByFile: {
            type: Boolean,
            required: true
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        fileByFileSupported: {
            type: Boolean,
            required: false,
            default: true
        },
        hideOnNarrowScreen: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'collapse-all-files',
        'expand-all-files',
        'toggle-file-by-file',
        'toggle-whitespace',
        'update-diff-view-type'
    ],
    computed: {
        expandButtonInfo () {
            const keys = keysFor(MR_EXPAND_ALL_FILES);
            return {
                title: MR_EXPAND_ALL_FILES.description,
                keys,
                tooltip: sanitize(`${MR_EXPAND_ALL_FILES.description} ${createHotkeyHtml(keys[0])}`)
            };
        },
        collapseButtonInfo () {
            const keys = keysFor(MR_COLLAPSE_ALL_FILES);
            return {
                title: MR_COLLAPSE_ALL_FILES.description,
                keys,
                tooltip: sanitize(`${MR_COLLAPSE_ALL_FILES.description} ${createHotkeyHtml(keys[0])}`)
            };
        }
    },
    mounted () {
        Mousetrap.bind(this.expandButtonInfo.keys, this.expandAllFiles);
        Mousetrap.bind(this.collapseButtonInfo.keys, this.collapseAllFiles);
    },
    beforeDestroy () {
        Mousetrap.unbind(this.expandButtonInfo.keys, this.expandAllFiles);
        Mousetrap.unbind(this.collapseButtonInfo.keys, this.collapseAllFiles);
    },
    methods: {
        expandAllFiles () {
            if (this.isLoading) return;
            this.$emit('expand-all-files');
        },
        collapseAllFiles () {
            if (this.isLoading) return;
            this.$emit('collapse-all-files');
        }
    }
};
